angular.module('leanlaw').controller('ReceivablesInvoicesListCtr', ['$scope', '$window', '$filter', 'messageBus', '$stateParams', 'viewInvoiceService', "alerts", 'singleRequest', "exportJson", 'reportsService', 'clientMatterManager', 'userService', function ($scope, $window, $filter, messageBus, $stateParams, viewInvoiceService, alerts, singleRequest, exportJson, reportsService, clientMatterManager, userService) {
  $scope.vm = {
    invoices: [],
    reportLabel: undefined,
    total: undefined,
    me: undefined
  };
  $scope.filter = {};
  $scope.agingCategory = formatAgingCategory;
  $scope.printFilterTime = new Date();
  activate();
  async function activate() {
    $scope.vm.me = await userService.me();
    const {
      clientId,
      matterId
    } = $stateParams;
    clientMatterManager.getClient(clientId).then(({
      label
    }) => {
      $scope.vm.reportLabel = label;
      if (matterId) {
        clientMatterManager.getMatter($stateParams.matterId).then(({
          label
        }) => {
          $scope.vm.reportLabel += ` / ${label}`;
        });
      }
    });
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      if (payload.filter.range) {
        loads();
      }
    });
    $scope.$on("report-sidebar-custom-filter-change", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
      loads();
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
  }
  async function loads() {
    $scope.vm.invoices = [];
    const query = reportsService.queryFromFilter($scope.filter);
    query.clientId = $stateParams.clientId;
    query.matterId = $stateParams.matterId;
    query.startDate = undefined;
    query.endDate = undefined;
    query.state = "open";
    if (!query) return;
    try {
      const list = await singleRequest.apiCall("invoices").listInvoices(query);
      if (!list) return;
      $scope.vm.invoices = list.invoices.map(invoice => ({
        date: invoice.invoiceDate,
        referenceLabel: invoice.reference,
        invoices: [invoice],
        amount: invoice.totals.billedAmount,
        matters: invoice.matters.length ? invoice.matters : [invoice.matter],
        type: 'Invoice',
        invoice
      }));
    } catch (err) {
      alerts.error(err);
    } finally {
      $scope.loading = false;
      adjustTotals();
    }
  }
  $scope.openInQBO = invoice => {
    $window.open(invoice.accounting.href);
  };
  $scope.viewInvoice = invoice => {
    viewInvoiceService.viewInvoice(invoice, true);
  };
  $scope.sendEmail = invoice => {
    viewInvoiceService.sendEmail(invoice);
  };
  $scope.print = function () {
    window.print();
  };
  function adjustTotals() {
    $scope.vm.total = {
      amount: $scope.vm.invoices.reduce((sum, i) => sum + i.amount, 0),
      balance: $scope.vm.invoices.reduce((sum, i) => sum + (i.invoice?.state?.balance || 0), 0)
    };
  }
  $scope.export = function () {
    const exp = $scope.vm.invoices.map(t => {
      const line = {
        Date: $filter("dateLogical")(t.date),
        "Invoice": t.referenceLabel,
        Matter: t.matters.map(m => m.label).join(', '),
        Amount: $filter("amount")(t.amount)
      };
      if (t.invoice) line.Balance = $filter("amount")(t.invoice.state.balance);
      if (t.invoice.due) line.Due = $filter("dateLogical")(t.invoice.due);
      line.Aging = formatAgingCategory(t.invoice).day;
      return line;
    });
    exportJson.downloadCsv(exp);
  };
  function formatAgingCategory(invoice) {
    const dueDays = Math.round((new Date() - new Date(invoice.due)) / (60 * 60 * 24 * 1000));
    const invoiceInfo = {};
    switch (true) {
      case dueDays <= 0:
        invoiceInfo.day = 'Current';
        break;
      case dueDays <= 30 && dueDays > 0:
        invoiceInfo.day = '1-30 Days';
        break;
      case dueDays > 30 && dueDays <= 60:
        invoiceInfo.day = '31-60 Days';
        break;
      case dueDays > 60 && dueDays <= 90:
        invoiceInfo.day = '61-90 Days';
        break;
      case dueDays > 90:
        invoiceInfo.day = '> 90';
        break;
      default:
        invoiceInfo.day = '';
    }
    invoiceInfo.dueDays = dueDays;
    return invoiceInfo;
  }

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the sort and filter on every digest.
  function updateFiltered() {
    if (!$scope.vm) return;
    $scope.vm.filteredInvoices = $filter('filter')($filter('orderBy')($scope.vm.invoices, $scope.vm.sort, $scope.vm.reverse), $scope.search) || [];
  }
  $scope.$watch('vm.invoices', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['vm.sort', 'vm.reverse'], updateFiltered);
}]);